import React from 'react';

const Health = () => <h2 data-test-id="health-page">Okay</h2>;

export default Health;
